import DemoIcon1 from '../../../assets/icons/WebExperience_LeftNav-Icon1.svg';
import DemoIcon2 from '../../../assets/icons/WebExperience_LeftNav-Icon2.svg';
import DemoIcon3 from '../../../assets/icons/WebExperience_LeftNav-Icon3.svg';
import DemoIcon4 from '../../../assets/icons/WebExperience_LeftNav-Icon4.svg';
import DemoIcon5 from '../../../assets/icons/WebExperience_LeftNav-Icon5.svg';
import AccessRecommendationsIntroImage from '../../../assets/images/SailPoint-StaticImages_AccessRecommendations-Intro.png';
import AccessRecommendationsOutroImage from '../../../assets/images/SailPoint-StaticImages_AccessRecommendations-Outro.png';
import IdentifyOutliersIntroImage from '../../../assets/images/SailPoint-StaticImages_IdentifyOutliers-Intro.png';
import IdentifyOutliersOutroImage from '../../../assets/images/SailPoint-StaticImages_IdentifyOutliers-Outro.png';
import LeaverIntroImage from '../../../assets/images/SailPoint-StaticImages_Leaver-Intro.png';
import LeaverOutroImage from '../../../assets/images/SailPoint-StaticImages_Leaver-Outro.png';
import OnboardingIntroImage from '../../../assets/images/SailPoint-StaticImages_Onboarding-Intro.png';
import OnboardingOutroImage from '../../../assets/images/SailPoint-StaticImages_Onboarding-Outro.png';
import RoleChangeIntroImage from '../../../assets/images/SailPoint-StaticImages_RoleChange-Intro.png';
import RoleChangeOutroImage from '../../../assets/images/SailPoint-StaticImages_RoleChange-Outro.png';
import BusinessAnimation from '../../../assets/animations/SP-Business-Animation-v1.0.mp4';
import NewEmployee from '../../../assets/images/walnut-screens/NewEmployee-AccessRequest-Walnut-Screen.png';
import AdjustingAccess from '../../../assets/images/walnut-screens/Adjusting-Access-Walnut-Screen.png';
import RemoveAccess from '../../../assets/images/walnut-screens/Remove-Access-Screen.png';
import MakeSmarterDecisions from '../../../assets/images/walnut-screens/MakeSmarter-Walnut-Screen.png';
import SpotAnomalous from '../../../assets/images/walnut-screens/SpotAnomalous-Walnut-Screen.png';

const data = {
  animation: BusinessAnimation,
  intro: {
    title: 'Interactive Demos',
    businessHeading: 'See the Business solution in action',
    heading: 'See the solution in action',
    instruction: 'Select a demo to begin'
  },
  demos: [
    {
      id: 1,
      title: 'New employee',
      actionText: 'access request',
      descriptionTitle: 'New employee access request',
      description: [
        'See how the IdentityNow Request Center streamlines the process of requesting access for yourself, your team, or anyone in your organization.'
      ],
      icon: DemoIcon1,
      illustration: OnboardingIntroImage,
      illustrationOutro: OnboardingOutroImage,
      outroTitle: 'Simplify access requests ',
      outroDescription: [
        'Requesting access to resources should be easy for your end-users for them and your helpdesk.'
      ],
      demoIdentifier: 'Access Request',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=ac6ceed1-0a5e-4119-981d-88e78fe7d077&screenId=40ad39f8-69a7-4631-aa0c-d3781faf6c9e&showGuide=true&showGuidesToolbar=false&showHotspots=true&isEmbed=true  ',
      walnutPlaceholder: NewEmployee
    },
    {
      id: 2,
      title: 'Adjusting access',
      actionText: 'as needed',
      descriptionTitle: 'Adjusting access as needed',
      description: [
        'Maintaining appropriate access across your organization is an everyday occurrence.  With people joining the company, changing roles and leaving keeping access up to date in a timely manner is critical.'
      ],
      icon: DemoIcon2,
      illustration: RoleChangeIntroImage,
      illustrationOutro: RoleChangeOutroImage,
      outroTitle: 'Adjusting access',
      demoIdentifier: 'Employee Mover',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=c2db6399-e3b2-41c3-b0e5-9061b7853c98&showGuide=true&showGuidesToolbar=false&showHotspots=true&isEmbed=true',
      outroDescription: [
        'Adjusting access as your organization changes is critical to maintaining a least privilege approach to access.  Having a system that makes it automatic helps you focus on other key items.'
      ],
      walnutPlaceholder: AdjustingAccess
    },
    {
      id: 3,
      title: 'Remove access',
      actionText: 'quickly',
      descriptionTitle: 'Remove access quickly',
      description: [
        'Quickly removing access is critical for organizations that want to maintain least privilege.',
        'Organizations that do not have an automated process to remove access for former employees open themselves up to potential security risks that could easily been avoided.'
      ],
      icon: DemoIcon3,
      illustration: LeaverIntroImage,
      illustrationOutro: LeaverOutroImage,
      outroTitle: 'Remove access quickly',
      demoIdentifier: 'Employee Leaver',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=4d007279-fe4e-4e1c-a293-4a7aac755948&showGuide=true&showGuidesToolbar=false&showHotspots=true&isEmbed=true',
      outroDescription: [
        'By integrating a strong identity security system with your HR system of record, automatically removing access when an employee leaves your organization is key to keeping access secure.'
      ],
      walnutPlaceholder: RemoveAccess
    },
    {
      id: 4,
      title: 'Make smarter',
      actionText: 'access decisions',
      descriptionTitle: 'Make smarter access decisions ',
      description: [
        'Access Recommendations help business managers and application owners make informed decisions, reduce certification fatigue, and improved productivity.'
      ],
      icon: DemoIcon4,
      illustration: AccessRecommendationsIntroImage,
      illustrationOutro: AccessRecommendationsOutroImage,
      outroTitle: 'Make smarter access decisions ',
      outroDescription: [
        'Automate low-risk access review and prioritize focus on high-risk user access that avoids rubber stamping which leads to incorrect access approvals.'
      ],
      demoIdentifier: 'Recommendations',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=6901be05-4bfb-4a21-ac6b-7d0d3f69c282&showGuide=true&showGuidesToolbar=false&showHotspots=true&isEmbed=true ',
      walnutPlaceholder: MakeSmarterDecisions
    },
    {
      id: 5,
      title: 'Spot anomalous',
      actionText: 'access',
      descriptionTitle: 'Spot anomalous access ',
      description: [
        'Leverage actionable access insights to proactively discover identity outliers and initiate a timely access certification.'
      ],
      icon: DemoIcon5,
      illustration: IdentifyOutliersIntroImage,
      illustrationOutro: IdentifyOutliersOutroImage,
      outroTitle: 'Spot anomalous access ',
      outroDescription: [
        'Identity Outliers can quickly discover identities with access that is anomalous.',
        'Provide appropriate remediate actions to address potentially risky access.',
        'Create a timely certification campaign for all discovered identity outliers.'
      ],
      demoIdentifier: 'Identity Outliers',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=315f0ba8-85f5-434a-9271-5d6a853677a2&showGuide=true&showGuidesToolbar=false&showHotspots=true&isEmbed=true ',
      walnutPlaceholder: SpotAnomalous
    }
  ]
};

export default data;
